import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import {
  SortableContainer,
  SortableElement,
  arrayMove
} from "react-sortable-hoc";
import FlatButton from "material-ui/FlatButton";
import { red900, pink600, white } from "material-ui/styles/colors";
import RemoveCircle from "material-ui/svg-icons/action/delete";

const SortableItem = SortableElement(({ value, onRemove, index }) => {
  return (
    <DivImages key={index} style={styles.container}>
      <FlatButton
        backgroundColor={pink600}
        hoverColor={red900}
        style={styles.removeButton}
        icon={<RemoveCircle color={white} />}
        onClick={onRemove(value)}
      />
      <img src={value} style={styles.image} alt="delete" title="photos" />
    </DivImages>
  );
});

const SortableList = SortableContainer(({ items, onRemove }) => {
  return (
    <DivImageBox>
      {items.map((value, index) => (
        <SortableItem
          key={`item-${index}`}
          index={index}
          value={value}
          onRemove={onRemove}
        />
      ))}
    </DivImageBox>
  );
});

class SortableImagePreview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: props.images
    };
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.images !== nextProps.images) {
      this.setState({
        items: nextProps.images
      });
    }
  }
  onSortEnd = ({ oldIndex, newIndex }) => {
    const oldPosition = this.state.items;
    this.setState({
      items: arrayMove(oldPosition, oldIndex, newIndex)
    });
    this.props.onUpdatePosition(arrayMove(oldPosition, oldIndex, newIndex));
  };
  render() {
    return (
      <SortableList
        items={this.state.items}
        onSortEnd={this.onSortEnd}
        onRemove={this.props.onRemove}
      />
    );
  }
}
const DivImageBox = styled.div`
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  flex-direction: row;
  min-height: 200px;
  padding: 16px 16px 16px 16px;
  border: 4px dashed #d6d6d6;
  border-radius: 5px;
  background-color: rgba(249, 247, 244, 0.45);
`;
const DivImages = styled.div`
  width: 180px;
  height: 180px;
`;

const styles = {
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    padding: 5
  },
  removeButton: {
    position: "absolute",
    top: "0.5rem",
    right: "0.5rem",
    minWidth: "2rem",
    opacity: 1
  },
  image: {
    maxHeight: "14rem",
    margin: "0.2rem",
    maxWidth: "100%"
  }
};

SortableImagePreview.propTypes = {
  images: PropTypes.array,
  sortEnd: PropTypes.func,
  onRemove: PropTypes.func,
  onUpdatePosition: PropTypes.func
};

SortableImagePreview.defaultProps = {
  images: []
};

export default SortableImagePreview;



// WEBPACK FOOTER //
// ./src/components/image/SortableImagePreview.js